import { Modal } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { Formik } from "formik";
import { Button, Form, SubmitButton, TextArea } from "../Form";

import { companyShape, productShape } from "../../shapes";

import { useApi, useTranslateError } from "../../hooks";
import { useNotifier, useTracking } from "../../context";
import { BadRequestError } from "../../api";

import { isSomething, htmlFormat, htmlLink } from "../../utils";
import { ContextualHelp } from "../Contextuals";
import CONFIGURATION from "../../configuration";

type Props = {
  onClose?: $TSFixMeFunction;
  serialNumber?: string;
  manufacturer?: companyShape;
  product?: productShape;
};

export function AssetPermissionModal({
  serialNumber,
  manufacturer,
  product,
  onClose,
}: Props) {
  const intl = useIntl();
  const api = useApi();
  const translateError = useTranslateError();
  const notifier = useNotifier();
  const tracking = useTracking();

  const showSuccessWithId = (id: $TSFixMe) => {
    notifier.showSuccess(intl.formatMessage({ id }));
  };

  const showWarningWithId = (id: $TSFixMe) => {
    notifier.showWarning(intl.formatMessage({ id }));
  };

  const showErrorWithId = (id: $TSFixMe) => {
    notifier.showError(intl.formatMessage({ id }));
  };

  const onSuccess = () => {
    showSuccessWithId("permission_request_create.success_notification");
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onClose();
  };

  const onError = (error: $TSFixMe) => {
    if (error instanceof BadRequestError && error.contains("taken")) {
      showErrorWithId("api.error.permission_request.taken");
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onClose();
    } else if (error instanceof BadRequestError && error.contains("no_owner")) {
      showErrorWithId("api.error.permission_request.no_owner");
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onClose();
    } else if (
      error instanceof BadRequestError &&
      error.contains("not_found_no_permission")
    ) {
      showWarningWithId("api.error.permission_request.asset_gone");
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onClose();
    } else {
      notifier.showError(translateError(error));
    }
  };

  const { mutate: postPermissionRequest } = api.post.useMutation(
    `/permission_requests/`,
    {
      onSuccess,
      onError,
    },
  );

  const onSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    const requestMessage = isSomething(values.message) ? values.message : null;
    const asset = {
      serial_number: serialNumber,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      manufacturer: { id: manufacturer.id },
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      product: { id: product.id },
    };
    tracking.trackEvent("PermissionRequest-AssetPermissionModal-send", {
      sn: serialNumber,
    });

    postPermissionRequest(
      { asset, request_message: requestMessage },
      {
        onSettled: () => {
          actions.setSubmitting(false);
        },
      },
    );
  };

  const onShow = () => {
    tracking.trackEvent("PermissionRequest-AssetPermissionModal-seen", {
      sn: serialNumber,
    });
  };

  const cancelPermissionRequest = () => {
    tracking.trackEvent("PermissionRequest-AssetPermissionModal-cancel");
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onClose();
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;

    return (
      <Form {...formProps}>
        <FormattedMessage
          id="ask_permissions.asset.modal_message"
          // @ts-expect-error TS(2322) FIXME: Type '{ serialNumber: string | undefined; br: () =... Remove this comment to see the full error message
          values={{
            ...htmlFormat,
            serialNumber,
          }}
        />
        <div className="space-after" />
        <TextArea
          {...formProps}
          name="message"
          id="ask-message"
          label={intl.formatMessage({ id: "label.message" })}
          placeholder={intl.formatMessage({
            id: "asset.access.request.message",
          })}
          autoFocus
        />
        <div className="btn-group justify-right">
          <SubmitButton
            id="button-permision-request-send"
            fetching={isSubmitting}
            text={intl.formatMessage({ id: "button.send" })}
          />
          <Button
            id="button-permision-request-cancel"
            onClick={cancelPermissionRequest}
            disabled={isSubmitting}
            text={intl.formatMessage({ id: "button.cancel" })}
          />
        </div>
      </Form>
    );
  };

  return (
    <Modal
      show
      restoreFocus={false}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      onHide={onClose}
      onShow={onShow}
      bsSize="large"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title>
          {intl.formatMessage({ id: "ask_permissions.asset.modal_title" })}
          <ContextualHelp
            title={intl.formatMessage({ id: "info.asset.modal_title" })}
            interactive
          >
            <p>
              <FormattedMessage
                id="user_profile.demo_data.description"
                values={{
                  ...htmlFormat,
                  // @ts-expect-error TS(2322) FIXME: Type '(...chunks: any[]) => Element' is not assign... Remove this comment to see the full error message
                  a: htmlLink({
                    href: CONFIGURATION.HELP_URL_DIGITAL_TWINS,
                    target: "_blank",
                  }),
                }}
              />
            </p>
          </ContextualHelp>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingTop: 0 }}>
        <Formik onSubmit={onSubmit} initialValues={{}}>
          {renderForm}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default AssetPermissionModal;
